module.exports = __webpack_public_path__ + "img/icon2(3).36b1c80b.png";